// @ts-nocheck
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {BaseSkeleton} from "@/components";
import BaseCarousel from "@/components/BaseCarousel";
import {useAuthStore} from "@/store/useAuth.store";
import {formatAmountSuffix} from "@/util/balance.util";
import betbyCarouselIcon from "../../../../../assets/images/betby_carousel_icon_light.png";
import fallbackImage from "../../../../../assets/images/fallback-image.svg";
import {useGetBigWinners} from "../../../../../hooks/gamesList/useGetBigWinners";
import {formatCurrency} from "../../../../../util/formatCurrency";

const cardCls = "rounded-2xl flex-[0_0_80px] w-[80px]";
const carouselWrapperCls = "relative overflow-hidden";
const cardImageCls = "mb-1.5 flex justify-center items-center";
const cardUsernameCls =
  "text-[11px] text-[var(--alternative-white)] font-normal text-center w-full ml-0 overflow-hidden whitespace-nowrap text-ellipsis";
const cardPrizeCls =
  "text-sm leading-tight text-[var(--button-background)] font-bold text-center w-full ml-0";
const leftShadowCls =
  "absolute top-0 left-0 w-[var(--size-7-5)] h-full pointer-events-none z-[2] bg-[linear-gradient(to_right,var(--gradient-start)_40%,var(--gradient-end)_100%)] max-[480px]:w-[15px]";
const rightShadowCls =
  "absolute top-0 right-0 w-[var(--size-7-5)] h-full pointer-events-none z-[2] bg-[linear-gradient(to_left,var(--gradient-start)_40%,var(--gradient-end)_100%)] max-[480px]:w-[15px]";

const HeadBand = () => {
  const {data, isPending} = useGetBigWinners();
  const winners = data?.data?.data?.winners || [];
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  const skeletonKeys = [
    "hb-skel-0",
    "hb-skel-1",
    "hb-skel-2",
    "hb-skel-3",
    "hb-skel-4",
    "hb-skel-5",
    "hb-skel-6",
    "hb-skel-7",
  ];

  const handleGameClick = useCallback(
    (provider, gameId) => {
      if (authStatus === "authenticated") {
        // Handle betby/sports navigation separately
        if (provider === "betby") {
          navigate("/sports");
        } else {
          navigate(`/games/${provider}/${gameId}`);
        }
      } else {
        handleShowAuthModal();
      }
    },
    [authStatus, navigate, handleShowAuthModal]
  );

  // Duplicate winners array to ensure smooth infinite scrolling
  // We need at least 4x the max slidesToShow (32 items) for seamless infinite loop
  const duplicatedWinners =
    winners.length > 0
      ? Array(Math.ceil(32 / winners.length))
          .fill(winners)
          .flat()
          .slice(0, 32)
      : [];

  const winnerCards = isPending ? (
    skeletonKeys.map(key => (
      <div
        key={key}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 0,
        }}
      >
        <BaseSkeleton
          width={64}
          height={64}
          radius={10}
          style={{marginBottom: "var(--space-2-5)"}}
        />
        <BaseSkeleton
          width={50}
          height={10}
          style={{marginBottom: "var(--space-1)"}}
        />
        <BaseSkeleton
          width={40}
          height={10}
          style={{marginBottom: "var(--space-1)"}}
        />
        <BaseSkeleton
          width={60}
          height={10}
        />
      </div>
    ))
  ) : duplicatedWinners.length > 0 ? (
    duplicatedWinners.map((winner, id) => (
      <div
        // biome-ignore lint/suspicious/noArrayIndexKey: duplicated list requires index as tiebreaker for composite key
        key={`${winner.user_id || winner.user_alias}-${winner.game_id}-${winner.amount_float}-${id}`}
        className={cardCls}
        onClick={() => {
          if (winner.game_id && winner.provider) {
            handleGameClick(winner.provider, winner.game_id);
          }
        }}
      >
        <div className={cardImageCls}>
          <img
            src={winner.provider === "betby" ? betbyCarouselIcon : winner.icon || fallbackImage}
            alt={winner.game_name || "icon game"}
            style={{width: 64, height: 64, objectFit: "cover", borderRadius: 10}}
            onError={e => {
              e.target.onerror = null;
              e.target.src = fallbackImage;
            }}
          />
        </div>
        <div className={cardUsernameCls}>@{winner.user_alias}</div>
        <div className={cardPrizeCls}>
          {formatAmountSuffix(winner.amount_float)} {formatCurrency(winner.currency)}
        </div>
      </div>
    ))
  ) : (
    <div style={{color: "red", width: "100%", textAlign: "center"}}>No hay ganadores para mostrar.</div>
  );

  return (
    <div style={{width: "100%", marginBottom: "var(--space-5)", paddingTop: "var(--space-4)"}}>
      <div className={carouselWrapperCls}>
        <div className={leftShadowCls} />
        <div className={rightShadowCls} />
        {isPending || duplicatedWinners.length >= 3 ? (
          <BaseCarousel
            arrayItems={winnerCards}
            secondsPerItem={2}
            pauseOnHover={true}
          />
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "var(--size-30)",
              color: "#888",
              fontSize: "var(--font-body-lg)",
            }}
          >
            {winners.length === 0 ? "No hay ganadores para mostrar." : "Cargando ganadores..."}
          </div>
        )}
      </div>
    </div>
  );
};
export default HeadBand;
